// AWS
import {
  get as apiGet,
  post as apiPost,
  put as apiPut,
  del as apiDel,
  patch as apiPatch,
} from "aws-amplify/api";

// Version
import { APP_VERSION } from "config";
import { versionMismatchAlert } from "Utils/Version/VersionMismatch";

const buildQueryParams = (params = {}) => ({
  ...params,
  version: APP_VERSION,
});

const parseErrorResponse = (error) => {
  if (!error.response) {
    throw error;
  }

  const errorBody = JSON.parse(error.response.body);
  if (errorBody.error === "VERSION_MISMATCH") {
    versionMismatchAlert();
    return;
  }

  throw new Error(errorBody.error);
};

const executeRequest = async (requestFn, apiName, path, options) => {
  try {
    const restOperation = requestFn({ apiName, path, options });
    const response = await restOperation.response;
    return response.body.json();
  } catch (error) {
    parseErrorResponse(error);
  }
};

// HTTP GET request
export const get = async (apiName, path, params, requestOptions = {}) => {
  return executeRequest(apiGet, apiName, path, {
    ...requestOptions,
    queryParams: buildQueryParams(params),
  });
};

// HTTP POST request
export const post = async (apiName, path, body, requestOptions = {}) => {
  return executeRequest(apiPost, apiName, path, {
    ...requestOptions,
    body,
    queryParams: buildQueryParams(),
  });
};

// HTTP PUT request
export const put = async (apiName, path, body, requestOptions = {}) => {
  return executeRequest(apiPut, apiName, path, {
    ...requestOptions,
    body,
    queryParams: buildQueryParams(),
  });
};

// HTTP DELETE request
export const del = async (apiName, path, params, requestOptions = {}) => {
  return executeRequest(apiDel, apiName, path, {
    ...requestOptions,
    queryParams: buildQueryParams(params),
  });
};

// HTTP PATCH request
export const patch = async (apiName, path, body, requestOptions = {}) => {
  return executeRequest(apiPatch, apiName, path, {
    ...requestOptions,
    body,
    queryParams: buildQueryParams(),
  });
};
